import Image from "next/image";
import { Button } from "../ui/button";
import { HugeiconsIcon } from "@hugeicons/react";
import { Album02Icon } from "@hugeicons/core-free-icons";
import { Typography } from "../ui/typography";
import { AccommodationImage } from "@/types/accommodations";
import { getAccommodationImageSrc } from "@/utils/getAccommodationImageSrc";

interface DesktopImageGridProps {
  images: AccommodationImage[];
  onViewAllClick: () => void;
}

export function DesktopImageGrid({
  images,
  onViewAllClick,
}: DesktopImageGridProps) {
  return (
    <div className="grid grid-cols-5 grid-rows-2 gap-2 h-[380px] relative rounded-lg">
      <Button
        onClick={onViewAllClick}
        className="absolute left-3 bottom-3 z-10 xl:!px-4 bg-background hover:bg-background rounded-[13px] h-11"
      >
        <HugeiconsIcon
          icon={Album02Icon}
          size={24}
          color="#000000"
          strokeWidth={1.5}
          className="size-6"
        />
        <Typography
          color="black"
          variant="bodySRegular"
          className="hidden xl:block"
        >
          مشاهده تمام تصاویر
        </Typography>
      </Button>
      {/* Main large image */}
      <div className="col-span-3 row-span-2 relative">
        <Image
          src={getAccommodationImageSrc(images[0]?.fileKey, "desktop")}
          alt="Villa main image"
          fill
          className="object-cover"
          priority
        />
      </div>

      {/* Smaller images */}
      {images.slice(1, 5).map((image, index) => (
        <div key={index} className="relative">
          <Image
            src={getAccommodationImageSrc(image?.fileKey, "desktop")}
            alt={`Villa image ${index + 2}`}
            fill
            className="object-cover"
          />
        </div>
      ))}
    </div>
  );
}
